import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Divider,
  Empty,
  message,
  Modal,
  Row,
  Space,
} from "antd";
import api from "utils/api";
import NestedFormViewer from "../NestedFormViewer";
import Loader from "Components/Loader";
import utils from "utils";
import AIFormConflictDrawer from "./AIFormConflictDrawer";
import { EditOutlined } from "@ant-design/icons";
import AIFormEdit from "./AIFormEdit";
import {
  CheckCircleFilled,
  CheckCircleOutlined,
  CloseOutlined,
  CloseCircleOutlined,
  CloseCircleFilled,
} from "Common/ReactIcons";
function AIFormCombinedView({
  loading,
  aiFormData,
  steAIFormData,
  is_editable,
  isSpeaking,
  chime_enabled,
  setLoading,
  getAllReviewedForms,
  patient_id,
  is_review_screen,
}) {
  const [editRecord, setEditRecord] = useState(null);
  const [isConflict, setIsConflict] = useState(false);
  const [conflictdata, setConflictdata] = useState({});
  const setConflict = () => {
    setIsConflict((prev) => !prev);
  };
  const handleFormSelectToggle = (sltdFormItem, propName) => {
    const { id } = sltdFormItem;
    const updatedFormData = aiFormData.map((item) => {
      if (item.id === id) {
        const isAccepted = propName === "is_accepted";
        return {
          ...item,
          is_accepted: isAccepted ? !item.is_accepted : false,
          is_rejected: isAccepted ? false : !item.is_rejected,
          is_reviewed: !item[propName],
          isSaved: false,
        };
      }
      return item;
    });
    steAIFormData(updatedFormData);
  };
  const handlePushToDB = (sortedData = aiFormData) => {
    setLoading(true);
    console.log("Summary data");
    console.log(sortedData);

    // const sortedData = aiFormData.sort((a, b) => a.id - b.id);
    const payloadData = {
      patient_id: patient_id,
      data: sortedData,
    };

    api
      .update_ai_form_view(payloadData)
      .then((res) => {
        api
          .save_ai_form(payloadData)
          .then((res) => {
            if (res.data.status === 200) {
              message.success("Data pushed to database successfully!");
              getAllReviewedForms();
            } else {
              message.error("Something went wrong");
              setLoading(false);
            }
          })
          .catch((error) => {
            message.error("Something went wrong");
            setLoading(false);
          });
      })
      .catch((error) => {
        message.error("Something went wrong");
      })
      .finally(() => {});
  };
  const checkDuplicatesFormValues = () => {
    const { updatedData, duparray } = updateData(aiFormData);
    if (Object.keys(duparray).length == 0) {
      handlePushToDB();
    } else {
      steAIFormData(updatedData);
      setConflictdata(duparray);
      setConflict(true);
    }
  };
  let savableitems =
    aiFormData.filter(
      (item) =>
        !(item.isSaved && item.is_reviewed) &&
        (item.is_accepted || item.is_rejected)
    ).length > 0;
  const confirmBtnAction = () => {
    const acceptedIds = Object.values(conflictdata)
      .flat()
      .reduce((acc, item) => {
        if (item.is_accepted) {
          acc.push(item.id);
        }
        return acc;
      }, []);
    const updatedFormData = aiFormData.map((item) => {
      if (item.isSaved && item.is_reviewed) {
        return item;
      }
      if (acceptedIds.includes(item.id)) {
        const isAccepted = true;
        return {
          ...item,
          is_accepted: true,
          is_rejected: false,
          is_reviewed: true,
          isSaved: false,
        };
      }
      return item;
    });
    steAIFormData(updatedFormData);
    setConflictdata({});
    setConflict();
    handlePushToDB(updatedFormData);
  };
  const aiFormRender = (formItemFull, index) => {
    const formItem = filterEmptyValues(formItemFull);
    if(isEmpty(formItem)){return <></>}    
      return (
        <>
          {formItemFull.id == editRecord ? (
            <AIFormEdit
              formData={formItemFull}
              setEditRecord={setEditRecord}
              key={index}
              steAIFormData={steAIFormData}
              is_review_screen={is_review_screen}
            />
          ) : (
            <div key={index}>
              <div
                // className={
                //   formItem.isSaved &&
                //   formItem.is_reviewed &&
                //   "saved-form-item"
                // }
                // key={index}
                // ref={endMessageFAQ}
                id={`message-list-item-${index}`}
                style={{
                  padding: "0px 12px",
                  borderBottom: `${is_review_screen ? 0 : 1}px solid #d0d5dd`,
                  // borderRadius: "4px",
                }}
              >
                {/* <Divider /> */}
                <Row align="middle">
                  <Col span={24} className="ques-rep-full-content">
                    {/* <div className="ques-reply">Question & Reply:</div> */}
                    <div className="questionAndAnswer">
                      <div>
                        <Row justify="space-between" gutter={[8]}>
                          <Col span={20} className="title">
                            {!is_review_screen && (
                              <div
                              // style={{ marginBottom: "10px" }}
                              >
                                <span className="ai-form-name-ans">
                                  {utils.capitalizeAndReplace(formItem?.title)}
                                </span>
                              </div>
                            )}
                            <div>
                              {!formItem.isObjectType && (
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "12px",
                                    // marginBottom: "20px",
                                  }}
                                >
                                  <div className="label-aiForm">
                                    {utils.capitalizeAndReplace(
                                      formItem?.label
                                    )}
                                  </div>
                                  <div className="display-Value">
                                    {formItem.displayValue != null &&
                                    formItem.displayValue !== ""
                                      ? typeof formItem.displayValue ===
                                        "boolean"
                                        ? formItem.displayValue
                                          ? "Yes"
                                          : "No"
                                        : formItem.displayValue
                                      : formItem.value[
                                          `is_${formItem?.label}`
                                        ] != null &&
                                        formItem.value[
                                          `is_${formItem?.label}`
                                        ] !== ""
                                      ? formItem.value[`is_${formItem?.label}`]
                                        ? "Yes"
                                        : "No"
                                      : ""}
                                  </div>
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col
                            span={4}
                            className="ai-form-check-right-container"
                          >
                            <Space
                              direction="horizontal"
                              size="small"
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              {formItem.isSaved && formItem.is_reviewed ? (
                                // {formItem.is_reviewed ? (
                                <div>
                                  {formItem.is_accepted ? (
                                    <Space
                                      // size="small"
                                      align="center"
                                    >
                                      <CheckCircleFilled
                                        style={{
                                          fontSize: "22px",
                                          color: "#099250",
                                        }}
                                      />
                                    </Space>
                                  ) : (
                                    <Space
                                      //  size="small"
                                      align="center"
                                    >
                                      <CloseCircleFilled
                                        style={{
                                          fontSize: "22px",
                                          color: "#ff4d4f",
                                        }}
                                      />
                                    </Space>
                                  )}
                                </div>
                              ) : (
                                <>
                                  <div>
                                    {!formItem.is_accepted ? (
                                      <CheckCircleOutlined
                                        style={{
                                          fontSize: "22px",
                                          color: "#099250",
                                        }}
                                        onClick={() =>
                                          handleFormSelectToggle(
                                            formItem,
                                            "is_accepted"
                                          )
                                        }
                                      />
                                    ) : (
                                      <CheckCircleFilled
                                        style={{
                                          fontSize: "22px",
                                          color: "#52c41a",
                                        }}
                                        onClick={() =>
                                          handleFormSelectToggle(
                                            formItem,
                                            "is_accepted"
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                  <div>
                                    {!formItem.is_rejected ? (
                                      <CloseCircleOutlined
                                        style={{
                                          fontSize: "22px",
                                          color: "#475467",
                                        }}
                                        onClick={() =>
                                          handleFormSelectToggle(
                                            formItem,
                                            "is_rejected"
                                          )
                                        }
                                      />
                                    ) : (
                                      <CloseCircleFilled
                                        style={{
                                          fontSize: "22px",
                                          color: "#ff4d4f",
                                        }}
                                        onClick={() =>
                                          handleFormSelectToggle(
                                            formItem,
                                            "is_rejected"
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                  {!isSpeaking && (
                                    <div>
                                      <EditOutlined
                                        onClick={() =>
                                          setEditRecord((prev) => {
                                            if (prev != null) {
                                              message.warning(
                                                "Click on Save or Cancel to proceed further"
                                              );
                                              return prev;
                                            } else {
                                              return formItem.id;
                                            }
                                          })
                                        }
                                      />
                                    </div>
                                  )}
                                </>
                              )}
                            </Space>
                          </Col>
                        </Row>
                      </div>
                      {formItem.displayValue ? (
                        <></>
                      ) : (
                        <NestedFormViewer
                          data={Object.fromEntries(
                            Object.entries(formItem.value).filter(
                              ([key]) => key !== `is_${formItem?.label}`
                            )
                          )}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              {formItem.is_exist && !formItem.is_reviewed && (
                <Row
                  align="middle"
                  justify="space-between"
                  style={{
                    background: "#FFF1F3",
                    // padding: "12px"
                    padding: "6px",
                  }}
                >
                  <Col style={{ fontSize: "12px" }}>
                    This form was answered and approved already. Do you want to
                    change your answer?
                  </Col>
                  <Col>
                    <Space>
                      <Button
                        style={{
                          height: "auto",
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }}
                        onClick={() =>
                          handleFormSelectToggle(formItem, "is_accepted")
                        }
                      >
                        <span style={{ fontSize: "12px" }}> YES</span>
                      </Button>
                      <Button
                        onClick={() =>
                          handleFormSelectToggle(formItem, "is_rejected")
                        }
                        style={{
                          height: "auto",
                          paddingTop: "0px",
                          paddingBottom: "0px",
                        }}
                      >
                        <span style={{ fontSize: "12px" }}> NO</span>
                      </Button>
                    </Space>
                  </Col>
                </Row>
              )}
            </div>
          )}
        </>);
     
  };
  const groupFormsByTitle = (forms) => {
    return forms.reduce((acc, form) => {
      if (!acc[form.title]) {
        acc[form.title] = [];
      }
      acc[form.title].push(form);
      return acc;
    }, {});
  };
  return (
    <div
      className="AIForm"
      // style={{
      //   ...(showAIForm ? {} : { display: "none" }),
      // }}
    >
      <div className="chatDivHeader">
        <div className="AFtitle">
          <div>AI Suggestions</div>
          {aiFormData.length > 0 && is_editable && savableitems && (
            // <Button
            <span
              // className="confirm-btn"
              loading={loading}
              size="small"
              onClick={() => {
                steAIFormData((prev) =>
                  prev.map((item) =>
                    item.isSaved && item.is_reviewed
                      ? item
                      : {
                          ...item,
                          is_rejected: false,
                          is_accepted: false,
                          is_reviewed: false,
                          isSaved: true,
                        }
                  )
                );
              }}
              // type="link"
            >
              RESET
            </span>
            //  </Button>
          )}
        </div>
        <div className="AFtitleDiv2">
          {aiFormData.length > 0 && is_editable && (
            <>
              <Button
                // className="confirm-btn"
                loading={loading}
                size="small"
                onClick={() => {
                  steAIFormData((prev) =>
                    prev.map((item) =>
                      item.isSaved && item.is_reviewed
                        ? item
                        : {
                            ...item,
                            is_accepted: false,
                            is_rejected: true,
                            is_reviewed: true,
                            isSaved: false,
                          }
                    )
                  );
                }}
                className="approveAllButton"
              >
                REJECT ALL
              </Button>
              <Button
                // className="confirm-btn"
                loading={loading}
                size="small"
                onClick={() => {
                  steAIFormData((prev) =>
                    prev.map((item) =>
                      item.isSaved && item.is_reviewed
                        ? item
                        : {
                            ...item,
                            is_accepted: true,
                            is_rejected: false,
                            is_reviewed: true,
                            isSaved: false,
                          }
                    )
                  );
                }}
                className="approveAllButton"
              >
                APPROVE ALL
              </Button>
              <Button
                // className="confirm-btn"
                loading={loading}
                size="small"
                onClick={checkDuplicatesFormValues}
                disabled={!savableitems}
                className="saveButton"
              >
                Save
              </Button>
            </>
          )}
          {/* <CloseOutlined className="closeChaticn" onClick={() => {}} /> */}
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <>
          {isSpeaking && aiFormData.length === 0 && (
            <Row justify="center" align="middle">
              <Col className="no-suggestion-aiForm">
                <div className="listening-text">
                  Continue speaking we are working on generating the content...
                </div>
              </Col>
            </Row>
          )}
          {!isSpeaking && aiFormData.length == 0 ? (
            <>
              <Row justify="center" align="middle">
                <Col className="no-suggestion-aiForm">
                  <div className="no-suggestion-text">
                    No suggestions to show!
                  </div>
                  <div className="review-suggestion">
                    Your reviewed suggestions will appear here
                  </div>
                </Col>
              </Row>
            </>
          ) : (
            <div
              className="AutoFormContentContainer"
              id="message-container"
              style={chime_enabled ? { height: "70vh" } : {}}
            >
              <div
                className="fullCardsContent"
                // ref={containerRef}
              >
                {is_review_screen ? (
                  <div className="review-suggestion-div">
                    {Object.entries(groupFormsByTitle(aiFormData)).map(
                      ([title, form_value]) => {
                        return (
                          <div className="form-class-div">
                            <div className="class-title-div">
                              {utils.capitalizeAndReplace(title)}
                            </div>
                            <div className="class-form-item-parent">
                              {form_value.map((formItemFull, index) => (
                                <div className="class-form-item">
                                  {aiFormRender(formItemFull, index)}
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                ) : (
                  <>{aiFormData.map(aiFormRender)}</>
                )}
              </div>
            </div>
          )}
        </>
      )}

      <AIFormConflictDrawer
        isConflict={isConflict}
        setConflict={setConflict}
        conflictdata={conflictdata}
        setConflictdata={setConflictdata}
        confirmBtnAction={confirmBtnAction}
      />
    </div>
  );
}

export default AIFormCombinedView;
export function filterEmptyValues(data) {
  // Helper function to check if a value is considered empty
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0; // Empty array
    } else if (typeof value === "object" && value !== null) {
      return Object.keys(value).length === 0; // Empty object
    } else {
      return (
        value === null ||
        value === undefined ||
        (typeof value ==='string' && value.trim() === '') ||
        value === "-" ||
        (typeof value === "number" && isNaN(value)) || value === 0

      ); // Null, undefined, or empty string
    }
  }

  if (Array.isArray(data)) {
    // Recursively filter array elements
    return data.map(filterEmptyValues).filter((item) => !isEmpty(item));
  } else if (typeof data === "object" && data !== null) {
    // Recursively filter object properties
    return Object.fromEntries(
      Object.entries(data)
        .map(([key, value]) => [key, filterEmptyValues(value)])
        .filter(([, value]) => !isEmpty(value))
    );
  } else {
    // Return primitive values as is
    return data;
  }
}
export function isEmpty(value) {
  return (typeof value === 'object' && (Object.keys(value).length === 0 || Array.isArray(value) && value.length === 0)) ||
         (typeof value ==='string' && value.trim() === '') ||( value === null ||
         value === undefined) ||(typeof value === "number" && isNaN(value));
}
function updateData(data) {
  const labelTitleMap = {};
  const duparray = {};

  // First pass: Count occurrences of each label-title combination
  data.forEach((item) => {
    if (item.isSaved && item.is_reviewed) {
      return;
    }
    if (item.is_accepted) {
      const key = `${item.label}-${item.title}`;
      if (labelTitleMap[key]) {
        labelTitleMap[key]++;
      } else {
        labelTitleMap[key] = 1;
      }
    }
  });

  // Second pass: Update items and push duplicates to duparray
  const updatedData = data.map((item) => {
    const key = `${item.label}-${item.title}`;
    const hasDuplicate = labelTitleMap[key] > 1;

    if (item.isSaved && item.is_reviewed) {
      return item;
    } else if (hasDuplicate && item.is_accepted) {
      const updatedItem = {
        ...item,
        is_rejected: false,
        is_accepted: false,
        is_reviewed: false,
        isSaved: true,
      };

      // Initialize the array for this label-title key if it doesn't exist
      if (!duparray[key]) {
        duparray[key] = [];
      }
      // Push the updated item into the array corresponding to this key
      duparray[key].push(updatedItem);

      return updatedItem;
    } else {
      return item;
    }
  });

  return { updatedData, duparray };
}
